const prevArrow = document.querySelector(".flickity-prev-next-button.previous");
const nextArrow = document.querySelector(".flickity-prev-next-button.next");

const navImages = document.querySelector(".Product__SlideshowNavScroller");

const getImageIdsByPosition = () => {
  const selectedImage = navImages.querySelector(".is-selected");

  let nextImageId, previousImageId;

  if (selectedImage.nextElementSibling) {
    nextImageId = selectedImage.nextElementSibling.dataset.mediaId;
  }

  if (selectedImage.previousElementSibling) {
    previousImageId = selectedImage.previousElementSibling.dataset.mediaId;
  }

  return { nextImageId, previousImageId };
};

// Because the theme is using another library "lazy sizes" to lazy load images,
// there is code in the theme.js which handles changing the images in the slideshow.
// This code also handles the lazy loading of the images.
// The flickity arrows will conflict with this code,
// so we need to remove the functionality of the arrows and just use the functionality of the theme.js code.

// remove next and previous class from arrows
nextArrow.classList.remove("next");
prevArrow.classList.remove("previous");

// add "no-functionality" class to arrows
nextArrow.classList.add("no-functionality-next");
prevArrow.classList.add("no-functionality-previous");

nextArrow.addEventListener("click", () => {
  const { nextImageId, previousImageId } = getImageIdsByPosition();

  if (nextImageId) {
    nextArrow.dataset.mediaId = nextImageId;
  }

  if (previousImageId) {
    prevArrow.dataset.mediaId = previousImageId;
  }
});

prevArrow.addEventListener("click", () => {
  const { nextImageId, previousImageId } = getImageIdsByPosition();

  if (nextImageId) {
    nextArrow.dataset.mediaId = nextImageId;
  }

  if (previousImageId) {
    prevArrow.dataset.mediaId = previousImageId;
  }
});
